import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { Fold } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { _ColAttributes2Description, _ColAttributes2Title, } from "@discovery/sonic-api-ng-optics";
import { ShareAttributes, _placeholderImage } from "./optics";
const ContestParticipatedView = React.lazy(() => import("./view"));
const getProps = (data) => {
    const titleM = Fold.preview(Fold.compose(_ColAttributes2Title, M._Just()), data);
    const title = M.fromMaybe(titleM, "");
    const descM = Fold.preview(Fold.compose(_ColAttributes2Description, M._Just()), data);
    const desc = M.fromMaybe(descM, "");
    const pageDetails = Fold.toArray(_placeholderImage, data);
    const placeholderImage = pageDetails.map(({ image }) => image);
    const shareAttributesM = Fold.preview(ShareAttributes, data);
    return {
        title,
        desc,
        placeholderImage,
        shareAttributesM,
    };
};
const ContestParticipated = ({ title, desc, placeholderImage, shareAttributesM, }) => (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
    React.createElement(ContestParticipatedView, { placeholderImage: placeholderImage, title: title, desc: desc, shareAttributesM: shareAttributesM })));
export const ComponentMapItem = mkSiteBuilderComponent(getProps, ContestParticipated);

